import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'components/molecules';
import Image from '../../atoms/Image/Image';
import './ImageGallery.scss';
import left from '../../../assets/images/facilitypage/left.svg';
import right from '../../../assets/images/facilitypage/right.svg';

export default function ImageGallery({
	isOpen,
	onClose,
	facility,
	images = [],
	startIndex = 0,
}) {
	const [activeIndex, setActiveIndex] = useState(startIndex);

	useEffect(() => {
		if (isOpen) {
			setActiveIndex(startIndex);
		}
	}, [startIndex, isOpen]);

	const handlePrev = useCallback(
		() => setActiveIndex((i) => Math.max(i - 1, 0)),
		[],
	);

	const handleNext = useCallback(
		() => setActiveIndex((i) => Math.min(i + 1, images.length - 1)),
		[images.length],
	);

	if (!images.length) return null;

	const mainImage = images[activeIndex];

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={facility?.name}
			bodyClassName="imageModal"
		>
			<div className="gallery-main-block">
				<div className="main-image-wrapper">
					<Image
						src={`https://images.selfstorage.com/large-compress/${mainImage}`}
						alt={`Photo of ${facility?.name}`}
						size="large"
						lazyLoad={false}
						className="facility-image"
					/>
				</div>

				<div className="thumbnails-wrapper">
					{images.map((img, index) => (
						<button
							key={img}
							type="button"
							className={`thumbnail-box ${
								activeIndex === index ? 'selected' : ''
							}`}
							onClick={() => setActiveIndex(index)}
						>
							<Image
								src={`https://images.selfstorage.com/large-compress/${img}`}
								alt={`Thumbnail ${index + 1}`}
							/>
						</button>
					))}
				</div>
				<div className="carousel-controls">
					<button
						className="carousel-btn"
						onClick={handlePrev}
						disabled={activeIndex === 0}
					>
						<Image
							src={left}
							className="carousel-icon"
						/>{' '}
						<span className="btn-text">Prev</span>
					</button>

					<span className="carousel-counter carousel-width">
						{activeIndex + 1} / {images.length}
					</span>

					<button
						className="carousel-btn"
						onClick={handleNext}
						disabled={activeIndex === images.length - 1}
					>
						<span className="btn-text"> Next</span>
						<Image
							src={right}
							className="carousel-icon"
						/>{' '}
					</button>
				</div>
			</div>
		</Modal>
	);
}

ImageGallery.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	facility: PropTypes.object,
	images: PropTypes.arrayOf(PropTypes.string),
	startIndex: PropTypes.number,
	children: PropTypes.node,
};
